import { render, staticRenderFns } from "./workWithPeriods.vue?vue&type=template&id=484788fc&scoped=true"
import script from "./workWithPeriods.vue?vue&type=script&lang=js"
export * from "./workWithPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484788fc",
  null
  
)

export default component.exports